__turbopack_context__.v({
  "card": "style-module-scss-module__vtM1ta__card",
  "icon": "style-module-scss-module__vtM1ta__icon",
  "text": "style-module-scss-module__vtM1ta__text",
  "title": "style-module-scss-module__vtM1ta__title",
});
